import { useRef, useState } from "react";
import { FileExportIcon } from "../Icons";
import Popover from "./Popover";

export default function FileExportBtn({
  onBtnCsvExport,
}: {
  onBtnCsvExport: () => void;
}) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="relative flex items-center">
      <button
        ref={btnRef}
        type="button"
        className="p-1 rounded-lg hover:text-custom-blue hover:scale-90 hover:bg-gray-100"
        onClick={() => setOpen((prev) => !prev)}
        title="Export file"
      >
        <FileExportIcon className="size-6" strokeWidth={1.5} />
      </button>

      <Popover
        open={open}
        onClose={() => setOpen((prev) => !prev)}
        triggerRef={btnRef}
        position="bottom"
        className="right-0 w-[150px]"
      >
        <button
          type="button"
          className="w-full p-1 text-sm rounded-lg hover:bg-gray-100"
          onClick={onBtnCsvExport}
        >
          Download CSV
        </button>
      </Popover>
    </div>
  );
}
